<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
</template>

<script>
// Tick used by the hero feature chips and the pricing tier lists.
export default { name: "CheckIcon" };
</script>
